import Overrides from "./Overrides"

export interface Props {
  children: React.ReactNode
}

export interface ComponentProps extends Props {}

export default Overrides
